class SprintButton {
	container
	padElement
	region
	button

	isPressed = false

	constructor(container, canvas) {
		this.container = container
		this.padElement = document.createElement('div')
		this.padElement.classList.add('sprint-pad')
		this.region = document.createElement('div')
		this.region.classList.add('region')

		this.button = document.createElement('button')
		this.button.innerHTML = `<i class="fa fa-person-running"></i>`
		this.button.classList.add('mobile-ui-button')

		this.padElement.append(this.button)
		this.container.append(this.padElement)

		this.setupPositions()

		window.addEventListener("resize", (e) => {
			this.setupPositions()
		})

		// Mouse events:
		this.button.addEventListener('click', (event) => {
			this.isPressed = !this.isPressed //Toggle

			this.button.style.opacity = 0.8
			this.button.classList.toggle("active", this.isPressed)
			this.sendEvent("toggle", {value: this.isPressed})
		})
	}

	setupPositions() {
		// Aligning pad position:
		this.padElement.style.top = this.container.offsetHeight + this.container.getBoundingClientRect().top
			- this.region.offsetHeight - 80 + 'px'
		this.padElement.style.left = '120px'
	}

	sendEvent(event, eventData = {}) {
		let moveEvent = new CustomEvent(event, {
			bubbles: false,
			detail: eventData
		})
		this.padElement.dispatchEvent(moveEvent)
	}
}


export default SprintButton
